export interface Costs {
    settlementType: SettlementType;
    cart: number; // cost per unit
    greenfee: number; // cost per unit
    caddy: number; // cost per unit
    vat: number;
    wt: number;

    // Adjusted amount to pay.
    // This is calculated by full cost + additional cost - use credit - coupon discount
    // Null means no adjustment
    adjustedAmount?: number | null;

    // Number of coupons used
    coupons: number;
    couponTotalDiscount: number;
    couponReserveItems?: ICouponReserveItem[];
    couponApplicableServices?: IApplicableServices;

    useCreditAmount: number;
    creditTransactionId: string | null;

    additionalCost: number;

    // After transfer money to golf course, these 3 fields will be set
    transferScheduledDate: Date | string;
    transferDate: Date | null;
    transferAmount: number | null;

    status: SettlementStatus;
    // After refund, these 3 fields will be set
    refundAt: Date | null;
    refundCoupon: number | null;
    refundCreditAmount: number | null;

    note?: string;
}

export interface ICouponReserveItem {
    itemId: string;
    code: string;
}

export interface IApplicableServices {
    greenFee: boolean;
    cart: boolean;
    caddy: boolean;
}

export enum SettlementType {
  TRANSFER = 'TRANSFER',
  BILL = 'BILL',
  HYBRID = 'HYBRID',
}

export enum SettlementStatus {
  INITIAL = 'INITIAL', // เริ่มต้น, ยังไม่โอน
  PENDING = 'PENDING', // ยังไม่ได้โอน (scheduled ไว้)
  TRANSFERRED = 'TRANSFERRED', // โอนแล้ว
  REFUND_PENDING = 'REFUND_PENDING', // รอคืนเงิน
  REFUND_COMPLETED = 'REFUND_COMPLETED', // คืนเงินแล้ว
  REFUND_REFUSED = 'REFUND_REFUSED', // สนามไม่คืนเงิน
}
